/**
 * replaceSceneNow - replace the scene on screen with a tutorial chapter's
 * scene in this call, not on the next game step.
 *
 * MUS-651: the tutorial used to switch scenes with the on-screen scene's
 * ScenePlugin.start(), which only queues the stop and the start; Phaser
 * applies them at the top of the next game step. The chapter's video resumes
 * as soon as the switch has been asked for, so whenever the next step came
 * late (frames held up while the video starts, the game loop asleep while the
 * page is hidden, a slow device) the video could reach the chapter's first
 * UpdateObjective before the new scene had registered for it. That event was
 * lost, the scene stayed idle, and the video then stopped at StartExercise
 * with no exercise on screen and nothing to tap. Level 0 "Highest and Lowest
 * Keys" sends that event 0.25 s into the chapter. The longer delays measured
 * there (the scene's init up to 1.5 s after the switch) were the tutorial's
 * 500 ms retry while the game booted, fixed where the tutorial handles the
 * game's ready event. This closes the remaining delay of one game step.
 *
 * `SceneManager.stop()` and `SceneManager.start()` are not queued, so the new
 * scene's init (which registers its listeners) has run when this returns.
 */

import type Phaser from 'phaser';
import { startSceneNow } from './startSceneNow';

export function replaceSceneNow(
  manager: Phaser.Scenes.SceneManager,
  onScreen: Phaser.Scene | null | undefined,
  key: string,
  data: object,
): void {
  const onScreenKey = onScreen?.sys?.settings?.key;
  if (onScreenKey && onScreenKey !== key) manager.stop(onScreenKey);
  startSceneNow(manager, key, data);
}
